import * as amplitude from "@amplitude/analytics-browser";

import { type Ampli, ampli } from "@/ampli";

/**
 * Loads the Ampli singleton against the Amplitude browser SDK, or leaves it disabled when the build carries no real
 * tracking key. Every call site reads that same singleton through `@/config`, so this runs once, at config time.
 */
export function setupAmpli(apiKey: string): Ampli {
  const enabled = Boolean(apiKey && apiKey !== "tracking-key-goes-here");
  if (enabled) {
    amplitude.init(apiKey, "", {
      autocapture: {
        pageViews: true,
        sessions: true,
      },
    });
  }
  ampli.load({ disabled: !enabled, client: { instance: amplitude } });
  return ampli;
}
